"use client";

import { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";

type Props = {
  liveaboardId: string;
  initialSaved: boolean;
  isAuthenticated: boolean;
  className?: string;
};

export default function LiveaboardWishlistHeart({
  liveaboardId,
  initialSaved,
  isAuthenticated,
  className = "",
}: Props) {
  const [saved, setSaved] = useState(initialSaved);
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isAuthenticated) {
      toast.error("Sign in to save liveaboards.");
      return;
    }
    if (busy) return;
    setBusy(true);
    try {
      if (saved) {
        await axios.delete("/api/liveaboards/wishlist", {
          params: { liveaboardId },
        });
        setSaved(false);
      } else {
        await axios.post("/api/liveaboards/wishlist", { liveaboardId });
        setSaved(true);
      }
    } catch {
      toast.error("Could not update wishlist.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      title={saved ? "Remove from saved" : "Save liveaboard"}
      aria-label={saved ? "Remove from saved" : "Save liveaboard"}
      disabled={busy}
      onClick={toggle}
      className={`rounded-full p-2 bg-white/90 shadow-sm border border-neutral-200 hover:border-cyan-600 transition ${className}`}
    >
      {saved ? (
        <AiFillHeart className="w-5 h-5 text-rose-500" />
      ) : (
        <AiOutlineHeart className="w-5 h-5 text-neutral-500" />
      )}
    </button>
  );
}
